import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderChangeSubObjectGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerUpdateWorkOrderChangeSubObject';

export const useUerUpdateWorkOrderChangeSubObject = (workOrderChangeId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [uerUpdateWorkOrderChangeSubObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerUpdateWorkOrderChangeSubObjectReset(undefined);
        onSuccess?.();
    }, [uerUpdateWorkOrderChangeSubObjectReset, onSuccess]);

    const [, uerUpdateWorkOrderChangeSubObjectStatus, , uerUpdateWorkOrderChangeSubObjectRequest] = useRequest({
        requestId,
        query: uerUpdateWorkOrderChangeSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerUpdateWorkOrderChangeSubObjectMakeRequest = useCallback(
        (input: ContractObjectUpdateInput) => {
            dispatch(uerUpdateWorkOrderChangeSubObjectRequest({ workOrderChangeId, input }));
        },
        [uerUpdateWorkOrderChangeSubObjectRequest, dispatch, workOrderChangeId],
    );

    useEffect(() => {
        uerUpdateWorkOrderChangeSubObjectReset(undefined);
    }, [uerUpdateWorkOrderChangeSubObjectReset]);

    return {
        uerUpdateWorkOrderChangeSubObjectStatus,
        uerUpdateWorkOrderChangeSubObjectMakeRequest,
    };
};
